<template>
  <div>
    <!-- <the-header></the-header>
    <the-footer></the-footer> -->
  </div>
</template>

<script>
// import TheHeader from './components/TheHeader.vue';
// import TheFooter from './components/TheFooter.vue';

export default {
  name: 'App',
  // components: {
  //   TheHeader,
  //   TheFooter,
  // }
}
</script>
<style lang="scss">
  @import url('#{$base-url}/etc.clientlibs/mchp/clientlibs/clientlib-base.min.css');
  @import url('#{$base-url}/etc.clientlibs/mchp/clientlibs/clientlib-site.min.css');
  @import url('#{$base-url}/etc.clientlibs/mchp/clientlibs/clientlib-dependencies.min.css');
</style>